import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
  // El contenedor acota el alto para que una foto vertical no empuje los
  // botones fuera de la pantalla.
  cropper: {
    maxHeight: '60vh',
    '& img': {
      maxHeight: '60vh',
    },
  },
  hint: {
    paddingBottom: theme.spacing(2),
  },
}));
